import {BaseModel} from './base.model';
import {ProfileContestantModel} from '@/models/user.model';

export class ReplyModel extends BaseModel {
  constructor(public message?: string,
              public contestant?: ProfileContestantModel) {
    super()
  }
}

export class ReplyDetailModel extends BaseModel {

  constructor(public message?: string,
              public contestant?: ProfileContestantModel) {
    super()
  }
}
